import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Plus = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="75" viewBox="0 0 75 74" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29.4183 0.075531H46.1559V28.264H74.7331V45.0016H46.1559V73.1911H29.4183V45.0016H0.840942V28.264H29.4183V0.075531Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
